import type { PlatformCapabilities } from './types';

let _platform: PlatformCapabilities | null = null;

export function setPlatformRef(platform: PlatformCapabilities): void {
  _platform = platform;
}

export function getPlatformRef(): PlatformCapabilities {
  if (!_platform) {
    throw new Error(
      'Platform not initialized. Call setPlatformRef() before accessing the platform.'
    );
  }
  return _platform;
}
